// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2vBwr","col":"styles_col__eqpY7","actions":"styles_actions__31c_t","conflict":"styles_conflict__14KP_"};